import { useState } from "react";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { navLinks } from "../../data/navigation";
import HeaderDropdown from "../HeaderDropdown/HeaderDropdown";
import useScrollPosition from "../../hooks/useScrollPosition";
import useDetectKeelMind from "../../hooks/useDetectKeelMind";
import { useEffect } from "react";
import HamburgerButton from "../HamburgerButton/HamburgerButton";
import useKeelLogoSwitch from "../../hooks/useKeelLogoSwitch";

function Header({
    dark = false,
    showSignIn = false,
    backgroundScrollThreshold = 50,
}) {
    const [showMenu, setShowMenu] = useState(false);
    const scrollPositon = useScrollPosition();
    const isKeelMind = useDetectKeelMind();
    const [backgroundState, setBackgroundState] = useState(false);

    const logoSrc = useKeelLogoSwitch(dark, backgroundState);

    useEffect(() => {
        if (scrollPositon >= backgroundScrollThreshold && !backgroundState) {
            setBackgroundState(true);
        } else if (
            scrollPositon < backgroundScrollThreshold &&
            backgroundState
        ) {
            setBackgroundState(false);
        }
    }, [scrollPositon, backgroundState, backgroundScrollThreshold]);

    function handleOpenClick() {
        setShowMenu(true);
    }

    return (
        <header
            id={styles.header}
            className={backgroundState ? styles.background : ""}
        >
            <HamburgerMenu
                data={navLinks}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                showSignIn={showSignIn || isKeelMind}
            />
            <div id={styles.left}>
                <Link to={"/"} aria-label="Link to home page">
                    <img src={logoSrc} alt="Keel logo" id={styles.keel_logo} />
                </Link>
            </div>
            <nav id={styles.middle}>
                {navLinks
                    .filter((l) => {
                        // hide hamburger only links on main nav (contact us)
                        // hide mind && lab links on keelmind.com domain

                        return (
                            !l.hamburgerOnly &&
                            !(
                                window.location.hostname.includes(
                                    "keelmind.com"
                                ) && l.hideOnMind
                            ) &&
                            !(
                                window.location.hostname.includes(
                                    "keel.digital"
                                ) && l.hideOnDigital
                            )
                        );
                    })
                    .map((l) =>
                        l.children ? (
                            <HeaderDropdown
                                key={l.name}
                                data={l.children}
                                text={l.name}
                                linkMode={true}
                                className={[
                                    styles.navlink,
                                    dark && !backgroundState
                                        ? styles.dark_text
                                        : null,
                                ].join(" ")}
                                bufferContainerStyle={{
                                    width: "max-content",
                                    translate: "-50%",
                                    left: "50%",
                                }}
                            />
                        ) : (
                            <Link
                                key={l.name}
                                className={[
                                    styles.navlink,
                                    dark && !backgroundState
                                        ? styles.dark_text
                                        : null,
                                ].join(" ")}
                                to={l.href}
                            >
                                {l.name}
                            </Link>
                        )
                    )}
            </nav>
            <div id={styles.right}>
                {(showSignIn || isKeelMind) && (
                    <HeaderDropdown
                        className={[
                            styles.header_button,
                            styles.navlink,
                            "outline-button",
                            dark && !backgroundState ? styles.dark_text : null,
                        ].join(" ")}
                        id={styles.sign_in}
                        text={"Sign In"}
                        data={[
                            {
                                href: "https://app.us.geta-head.com/app/gah/",
                                name: "United States",
                            },
                            {
                                href: "https://app.ca.geta-head.com/app/gah/",
                                name: "Canada",
                            },
                        ]}
                    />
                )}
                <Link
                    id={styles.contact_us}
                    className={[styles.header_button, "orange-button"].join(
                        " "
                    )}
                    to="/contact-us"
                >
                    Contact Us
                    <img src="/images/up-right-arrow.svg" alt="" />
                </Link>
                <HamburgerButton
                    dark={dark && !backgroundState}
                    id={styles.hamburger_button}
                    onClick={handleOpenClick}
                />
            </div>
        </header>
    );
}

export default Header;
